function Marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);
  if (parentSelector) {
    const clone = parentSelector.innerHTML;
    const firstElement = parentSelector.children[0];
    let i = 0;
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);

    setInterval(function () {
      firstElement.style.marginLeft = `-${i}px`;
      if (i > firstElement.clientWidth) {
        i = 0;
      }
      i = i + speed;
    }, 0);
  }
}

//after window is completed load
//1 class selector for marquee
//2 marquee speed 0.2
window.addEventListener("load", Marquee(".marquee-wrapper", 0.1));

function addCloseButton() {
  const closeIcon =
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg>';
  //search for #trustpilot-gtm-floating and add close button
  const trustpilotFloating = document.querySelector(
    "#trustpilot-gtm-floating-wrapper"
  );
  if (trustpilotFloating) {
    //check if cookie is set for 24 hours
    const cookie = document.cookie;
    if (cookie.includes("trustpilot-floating=closed")) {
      trustpilotFloating.style.display = "none";
    }

    const closeButton = document.createElement("button");
    closeButton.classList.add("close-trustpilot-floating");
    closeButton.innerHTML = closeIcon;
    closeButton.addEventListener("click", () => {
      //add cookie for 24 hours to keep it closed
      document.cookie = "trustpilot-floating=closed; max-age=86400; path=/";
      trustpilotFloating.style.display = "none";
    });
    trustpilotFloating.appendChild(closeButton);
  }
}

// MutationObserver um das Hinzufügen des Trustpilot Elements zu überwachen
function observeTrustpilotElement() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          // Prüfe ob das hinzugefügte Element das Trustpilot Element ist
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.id === "trustpilot-gtm-floating-wrapper") {
              addCloseButton();
              observer.disconnect(); // Observer stoppen nach dem ersten Fund
            }
            // Prüfe auch in Kindelementen
            const trustpilotElement =
              node.querySelector &&
              node.querySelector("#trustpilot-gtm-floating-wrapper");
            if (trustpilotElement) {
              addCloseButton();
              observer.disconnect(); // Observer stoppen nach dem ersten Fund
            }
          }
        });
      }
    });
  });

  // Observer für das Body Element starten
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// Observer starten wenn DOM geladen ist
document.addEventListener("DOMContentLoaded", observeTrustpilotElement);
